import { supabase } from '../lib/supabase'

export type InboxSeverity = 'low' | 'medium' | 'high'

export interface InboxCategory {
  key: string
  label: string
  count: number
  severity: InboxSeverity
  route: string
}

export const getPharmacyInbox = async (
  pharmacyId: string,
): Promise<InboxCategory[]> => {
  const { data, error } = await supabase.rpc('get_pharmacy_inbox' as never, {
    p_pharmacy_id: pharmacyId,
  } as never)
  if (error) throw error
  return ((data ?? []) as Array<Record<string, unknown>>).map((r) => ({
    key: r.key as string,
    label: r.label as string,
    count: Number(r.count),
    severity: r.severity as InboxSeverity,
    route: r.route as string,
  }))
}

export const getInboxTotal = (categories: InboxCategory[]): number =>
  categories.reduce((sum, c) => sum + c.count, 0)

export const getInboxMaxSeverity = (
  categories: InboxCategory[],
): InboxSeverity | null => {
  const active = categories.filter((c) => c.count > 0)
  if (active.length === 0) return null
  if (active.some((c) => c.severity === 'high')) return 'high'
  if (active.some((c) => c.severity === 'medium')) return 'medium'
  return 'low'
}
